/* eslint-disable react/require-default-props */
/* eslint-disable no-undef */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/require-default-props */
import { IconButton } from '@material-ui/core';
import React from 'react';
import {
  Avatar, Item, ItemList, Sigla, Small,
} from './styles';

interface Props {
  sigla: string;
  name: string;
  icone: JSX.Element;
  nameColor?: string;
}

const ItemUser: React.FC<Props> = ({
  sigla, name, icone, nameColor,
}) => (
  <ItemList>
    <Item>
      <Avatar>
        <Sigla>
          {sigla}
        </Sigla>
      </Avatar>
      <Small color={nameColor}>{name}</Small>
    </Item>
    <IconButton>
      {icone}
    </IconButton>
  </ItemList>
);
export default ItemUser;
